import Swiper from 'swiper';

// Swiper 3up driver slider
// This doesn't work properly if there are multiple elements on the page that
// can't be differentiated. If you want to have multiple "3up" swipers on the
// same page then give the individual swipers a unique data-swiper-id attribute.
const init = function(swiperTarget) {
  const swiperElements = document.querySelectorAll(swiperTarget),
    arrowsSelector = '.js-swiper-3up-arrows',
    nextSelector = '.js-swiper-3up-button-next',
    previousSelector = '.js-swiper-3up-button-prev',
    paginationSelector = '.js-swiper-3up-pagination';

  let uniqueSwiperTarget = swiperTarget;

  swiperElements.forEach(swiperElement => {
    const swiperId = swiperElement.dataset.swiperId,
      arrows = swiperElement.parentElement.querySelector(arrowsSelector),
      pagination = swiperElement.parentElement.querySelector(
        paginationSelector
      );

    if (swiperId) {
      uniqueSwiperTarget = `${swiperTarget}[data-swiper-id="${swiperId}"]`;
    }

    new Swiper(uniqueSwiperTarget, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      loop: false,
      grabCursor: true,
      loopFillGroupWithBlank: true,
      preloadImages: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: `${uniqueSwiperTarget} ~ ${paginationSelector}`,
        clickable: true,
      },
      navigation: {
        nextEl: `${uniqueSwiperTarget} ~ ${arrowsSelector} > ${nextSelector}`,
        prevEl: `${uniqueSwiperTarget} ~ ${arrowsSelector} > ${previousSelector}`,
      },
      on: {
        init: function() {
          if (this.slides.length <= 3 && arrows && pagination) {
            arrows.classList.add('hidden');
            pagination.classList.add('hidden');
          }
        },
      },
      breakpoints: {
        991: {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
          freeMode: true,
          loop: false,
        },
      },
    });
  });
};

export default {
  init,
};
